import { jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import classNames from 'classnames';
import { ScrollArea } from '../../ScrollArea/ScrollArea.es.js';
import { useTermsOfServiceContext } from '../Provider/index.es.js';

const TermsOfServiceScroll = ({ isScrollCompleted, onScrollCompleted, className, children, ...rest })=>{
    const [{ isSanitized }] = useTermsOfServiceContext();
    /**
     * Handle content on scroll.
     */ const handleOnScroll = useCallback(({ atBottom })=>{
        if (atBottom && !isScrollCompleted) {
            onScrollCompleted?.();
        }
    }, [
        onScrollCompleted,
        isScrollCompleted
    ]);
    /**
     * Handle scroll area update.
     */ const handleOnUpdate = useCallback((scrollPosition)=>{
        // Set to completed if not loading and scrollbar is not present
        if (!isScrollCompleted && isSanitized && scrollPosition.scrollHeight <= scrollPosition.clientHeight) {
            onScrollCompleted?.();
        }
    }, [
        isScrollCompleted,
        isSanitized,
        onScrollCompleted
    ]);
    return jsx(ScrollArea, {
        className: classNames('size-full', className),
        "data-testid": "terms-of-service-scroll",
        onScroll: handleOnScroll,
        onUpdate: handleOnUpdate,
        ...rest,
        children: children
    });
};

export { TermsOfServiceScroll };
//# sourceMappingURL=TermsOfServiceScroll.es.js.map
